import { PatchCulpritPersonalInformationQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritPersonalInformation/patchCulpritPersonalInformationQuery.type';
import { patchCulpritPersonalInformationFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/patchCulpritPersonalInformation/patchCulpritPersonalInformationQueryFunction';
import { useMutation } from '@tanstack/react-query';

export const usePatchCulpritPersonalInformationQueryOptions = () => {
  return useMutation({
    mutationKey: ['CulpritPersonalInformation'],
    mutationFn: (params: PatchCulpritPersonalInformationQueryParamsType) =>
      patchCulpritPersonalInformationFunction(params),
  });
};
